import React, { Component } from 'react'
import PropTypes from 'prop-types'
import {
  Dialog,
  Tabs,
  Tab,
} from 'react-toolbox'
import CSSModules from 'react-css-modules'

import styles from './styles.scss'

class AddPopupDialog extends Component {
  constructor(props) {
    super(props)
    this.state = {
      tabIndex: 0,
    }
  }

  closeDialog() {
    return () => {
      const {
        onTogglePopup,
        onUpdateConfig,
        onUpdateConfigSource,
        onRefreshFilter,
      } = this.props

      // hide popup
      onTogglePopup()
      // clear list of selected configs
      onUpdateConfig([])
      onUpdateConfigSource([])
      onRefreshFilter()
    }
  }

  render() {
    const {
      togglePopup,
      tabTitles,
      children,
    } = this.props

    const multiTabs = Array.isArray(children)

    return (
      <Dialog
        theme={styles}
        active={togglePopup}
        onOverlayClick = {this.closeDialog()}
        onEscKeyDown={this.closeDialog()}
      >
        <Tabs
          onChange={(index) => this.setState({tabIndex: index})}
          index={multiTabs ? (this.state.tabIndex >= children.length ? 0 : this.state.tabIndex) : 0}
          theme={styles}
          fixed
        >
          { multiTabs ?
            children.map((value, index) => (
              <Tab key={ index } label={ tabTitles[index] ? tabTitles[index] : '' }>
                { value }
              </Tab>
            )) :
            <Tab label={ tabTitles[0] ? tabTitles[0] : '' }>
              { children }
            </Tab>
          }
        </Tabs>
      </Dialog>
    )
  }
}

AddPopupDialog.propTypes = {
  togglePopup: PropTypes.bool.isRequired,
  tabTitles: PropTypes.array.isRequired,
  onTogglePopup: PropTypes.func.isRequired,
  onUpdateConfig: PropTypes.func.isRequired,
  onUpdateConfigSource: PropTypes.func.isRequired,
  onRefreshFilter: PropTypes.func.isRequired,
}

export default CSSModules(AddPopupDialog, styles)
